import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MessengerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MessengerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 2.00194C6.59604 1.89539 2.12436 6.18076 2.00098 11.5843C2.01508 14.335 3.23304 16.9415 5.33397 18.717V21.5834C5.33397 21.8135 5.52052 22 5.75061 22C5.82869 22 5.90521 21.978 5.97141 21.9367L8.29368 20.486C9.47685 20.9385 10.7333 21.1693 12 21.1668C17.404 21.2733 21.8756 16.9879 21.999 11.5844C21.8756 6.18076 17.404 1.89539 12 2.00194Z"
        fill="#2196F3"
      />
      <path
        d="M18.5829 8.83499C18.4589 8.66883 18.2316 8.61911 18.0496 8.71832L13.7167 11.0806L11.0211 8.76913C10.8558 8.62743 10.6093 8.63684 10.4554 8.79081L5.45586 13.7903C5.29365 13.9535 5.29443 14.2173 5.45766 14.3795C5.58815 14.5092 5.78825 14.538 5.94999 14.4503L10.2829 12.088L12.9809 14.4003C13.1462 14.542 13.3928 14.5326 13.5467 14.3786L18.5462 9.37907C18.6919 9.23202 18.7075 9.00028 18.5829 8.83499Z"
        fill="#FAFAFA"
      />
    </svg>
  );
};

export default MessengerIcon;
